/**
 * Extracts the filename from a file reference path (e.g., gs://bucket/path/file.png -> file.png).
 * Handles both forward and backward slashes.
 */
export function extractFilename(fileReference: string): string {
  const pathParts = fileReference.split(/[/\\]/);
  return pathParts[pathParts.length - 1] !== '' ? pathParts[pathParts.length - 1] : fileReference;
}

/**
 * Fetches a URL and converts it to a blob URL for caching.
 * Used to cache files locally when server sends cache-control: max-age=0
 */
export async function fetchAsBlob(url: string): Promise<string> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch file: ${response.statusText}`);
  }

  const blob = await response.blob();
  return URL.createObjectURL(blob);
}
